// extracted by mini-css-extract-plugin
export default {"pagination":"style_pagination__5jYac","paginationCircle":"style_paginationCircle__dpxw8","paginationContent":"style_paginationContent__OE98e"};